// extracted by mini-css-extract-plugin
module.exports = {"label":"SpinnerGroup_label__XyY1a"};